import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-external',
  templateUrl: './external.component.html',
  styleUrls: ['./external.component.css']
})
export class ExternalComponent implements OnInit {

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
    if (localStorage && !localStorage['language']){
        localStorage['language'] = language;
    }
}

  constructor(private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _snackBar: MatSnackBar) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
  }

  User:{[k: string]: any} = {};
  RememberMeData = {};

  rememberMe:boolean;
  isRegistering:boolean;

  loginUserName:string;
  loginPassword:string;
  public BackendServiceUrl = this.service.APIUrl;

  public DocumentStatus:string;
  public DocumentDueDate:string;
  public DocumentPrice:string;
  public DocumentCurrency:string;

  ngOnInit(): void {
    this.SetDefaultLanguage();
    this.User.Id = "ExternalVisitor" 
  }

  SetDefaultLanguage(){

    if(this.getLanguage() == ''){
      this.setLanguage("en");
    }
  }

  openSnackBar(message: string, action: string, designClass: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: [designClass]
    });
  }
}
